<template>

    <div class="input-group">

        <dropzone
            :url="url"
            :maxNumberOfFiles="10"
            :value="value"
            @input="v => $emit('input', v)"
            @success="addedImage"
            @removed="removedImage"
            @clicked="useImage"
            ref="dropzone"
            ></dropzone>

    </div>

</template>


<script>
import Dropzone from 'js/components/elements/Dropzone.vue'

import api from 'js/api/resources'

export default {

    props: {
        category: {
            type: String,
            required: true,
        },
        value: {},
    },

    components: { Dropzone },

    vuex: {
        actions: {
            storeImage: ({ dispatch }, data) => {
                dispatch('ADD_IMAGES', [data])
            },
        }
    },

    methods: {

        addedImage: function(file, data) {
            this.storeImage(data)
            this.$emit('added', data)
        },

        removedImage: function(file, data) {
            api.deleteImage(data.id)
                .then(() => this.$emit('removed', data) )
        },

        useImage: function(file, data) {
            this.$emit('use', data)
        },

    },

    computed: {

        url: function() {
            return this.$http.options.root + '/images/' + this.category
        },

    }

}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// ImageUpload.vue?6467918d